import { createTheme } from "@mui/material"

interface IHiabColors {
  blackPrimary: string
  greyPrimary: string
  redPrimary: string
  whitePrimary: string
  bluePrimary: string
}

export const hiabColors: IHiabColors = {
  blackPrimary: "#000000",
  greyPrimary: "#37424A",
  redPrimary: "#D52B1E",
  whitePrimary: "#FFFFFF",
  bluePrimary: "#3EB1C8",
}

const hiabTheme = createTheme({
  palette: {
    primary: {
      main: hiabColors.greyPrimary,
    },
    secondary: {
      main: hiabColors.redPrimary,
    },
  },
  typography: {
    h1: {
      fontFamily: '"Arial"',
      fontWeight: 400,
      letterSpacing: 0.8,
    },
    h2: {
      fontFamily: '"Anton"',
      fontWeight: 400,
      letterSpacing: 0.8,
      fontSize: 38,
    },
    h3: {
      fontFamily: '"Anton"',
      fontWeight: 400,
      letterSpacing: 0.8,
      fontSize: 22,
    },
    h4: {
      fontFamily: '"Arial"',
      fontWeight: "bold",
      letterSpacing: 0.8,
      fontSize: 16,
    },
    h5: {
      fontFamily: '"Arial"',
      fontWeight: 400,
      letterSpacing: 0.8,
    },
    h6: {
      fontFamily: '"Arial"',
      fontWeight: 400,
      letterSpacing: 0.8,
    },
    body1: {
      fontFamily: '"Arial"',
      fontWeight: 400,
    },
    body2: {
      fontFamily: '"Arial"',
      color: hiabColors.greyPrimary,
      fontWeight: 400,
    },
    subtitle1: {
      fontFamily: '"Arial"',
      fontWeight: 400,
    },
    subtitle2: {
      fontFamily: '"Arial"',
      fontWeight: 400,
    },
    button: {
      fontFamily: '"Arial"',
      fontWeight: 400,
    },
    caption: {
      fontFamily: '"Arial"',
      fontWeight: 400,
    },
    overline: {
      fontFamily: '"Arial"',
      fontWeight: 400,
    },
  },
})

export default hiabTheme
